/* eslint-disable */
<template>
  <div class="specialist-schedule-pdf">
    <div :key="dataKey" class="pdf-panel">
      <div class="pdf-content p-2" v-if="bookings.length > 0">
        <div class="p-1">
          <div class="pdf-header">
            <div class="row">
              <div class="col-4">
                <strong>{{ formatDate(bookings[0].bookingDetails.dateTime, 'dddd, DD MMMM YYYY') }}</strong> <br/>
                <b>{{ specialist.fullName }}</b> <br/>
                <span v-if="bookings && bookings.length > 0">
                  {{ bookings[0].location.name ? bookings[0].location.name + ', ' : '' }}
            <span v-if="bookings[0].location.address1">{{ bookings[0].location.address1 }} , <br></span>
             <span v-if="bookings[0].location.address2">{{ bookings[0].location.address2 }} ,<br> </span>
                  <span v-if="bookings[0].location.cityName">{{ bookings[0].location.cityName }}, </span>
                  <span v-if="bookings[0].location.state">{{ bookings[0].location.state }},</span>
            {{ bookings[0].location.postcode }}
                </span>
              </div>
              <div class="col-4">
                <span class="increased-line-height"><strong>Red Health: </strong>Dictation@redhealth.com.au<br/></span>
                <span class="increased-line-height"><strong>Phone:</strong> 1300 100 733<br/></span>
                <i style="margin-top: 10px">Please upload your dictation to Red Health Online, <br/>
                  or email dictation@redhealth.com.au</i>
              </div>
              <div class="col-4">
                <img class="img-fluid" src="@/assets/images/red_health_logo.svg"/>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(booking, index) in bookings" :key="index" class="my-3 break-page">
          <div class="row m-0" style="min-height: 60px; background: #f0f0f0">
            <div class="col-4 border px-2 py-1">
              <div>
                <div v-if="pathProps">
                  <a :href="pathProps + '?id=' + booking.bookingDetails.id" target="_blank">
                    {{ formatTime(booking.bookingDetails) }} - #{{ booking.bookingDetails.id }} -
                    {{ getBookingTypeName(booking.bookingDetails.typeId) }}
                  </a>
                  <span
                      v-if="(booking.bookingDetails.typeId !== 7 && booking.bookingDetails.videoLinkUrl && booking.bookingDetails.DeliveryMethod === 2) || (booking.bookingDetails.typeId === 7 && !!booking.bookingDetails.ShowVideoLinkUrl)"> - <a :href="booking.bookingDetails.videoLinkUrl.includes('http') ? booking.bookingDetails.videoLinkUrl : `http://${booking.bookingDetails.videoLinkUrl}`" target="_blank">Join Video Link</a></span>
                </div>
                <span v-else>{{ formatTime(booking.bookingDetails) }} - #{{
                    booking.bookingDetails.id
                  }} - {{ getBookingTypeName(booking.bookingDetails.typeId) }}<span
                      v-if="(booking.bookingDetails.typeId !== 7 && booking.bookingDetails.videoLinkUrl && booking.bookingDetails.DeliveryMethod === 2) || (booking.bookingDetails.typeId === 7 && !!booking.bookingDetails.ShowVideoLinkUrl)"> - <a :href="booking.bookingDetails.videoLinkUrl.includes('http') ? booking.bookingDetails.videoLinkUrl : `http://${booking.bookingDetails.videoLinkUrl}`"
                                                                             target="_blank">Join Video Link</a></span></span>
              </div>
            </div>
            <div class="col-4 border px-2 p-1 text-break">
              <div>
                <div><b>Claimant location</b></div>
                <div style="word-wrap: break-word"><span>{{ booking.bookingDetails.ClaimantLocation }}</span></div>
              </div>
            </div>
            <div class="col-4 border px-2 p-1 text-break">
              <div>
                <div><b>Surrogate Details</b></div>
                <div style="word-wrap: break-word;">
                  <span v-html="getName(booking.bookingDetails, 2)"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-2 border px-2 py-1"><b>Claimant</b></div>
            <div class="col-2 border px-2 py-1"><b>Preferred Name</b></div>
            <div class="col-2 border px-2 py-1"><b>Referring Client</b></div>
            <div class="col-6 border px-2 py-1"><b>Overview of Conditions</b></div>
          </div>
          <div class="row m-0">
            <div class="col-2 border px-2 py-1">
              {{ booking.casesDetails.claimantFullName }}
            </div>
            <div class="col-2 border px-2 py-1">{{ booking.bookingDetails.PreferredGivenName || '' }}</div>
            <div class="col-2 border px-2 py-1">{{ booking.clientDetails.clientName }}</div>
            <div class="col-6 border px-2 py-1 block-2">
              <div class="vertical-long-text">
                {{ booking.bookingDetails.fullBodyAreas + (booking.bookingDetails.bodyAreaOther ? ', ' +booking.bookingDetails.bodyAreaOther : '') }}
                {{(booking.bookingDetails.fullBodyAreas || booking.bookingDetails.bodyAreaOther) && booking.bookingDetails.fullPersonConditions ? ', ' : '' }}
                {{ booking.bookingDetails.fullPersonConditions }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="availability.generalInformation.trim() != ''" class="mt-1">
          <div class="mb-2">General Information for the day</div>
          <div class="general-information-content" v-html="availability.generalInformation"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'

export default {
  name: 'SpecialistAvailabilityBookingPdf',
  props: ['pathProps'],
  components: {},
  data() {
    return {
      specialist: utilities.initSpecialist(),
      availability: utilities.initAvailability(),
      bookings: [],
      bookingsByLocation: {},

      bookingTypes: [],
      dataKey: 0,
    }
  },
  computed: {},
  methods: {
    getName(value, type) {
      if (type === 1) {
        let str = ''
        if (value.interpreterName) {
          str += '<b>N: </b>' + value.InterpreterName + '&nbsp'
        }
        if (value.interpreterCompany) {
          str += '<b>C: </b>' + value.InterpreterCost + '&nbsp'
        }
        return str
      } else if (type === 2) {
        let str = ''
        if (value.surrogateName) {
          str += '<b>N: </b>' + value.surrogateName + '&nbsp'
        }
        if (value.surrogateCompany) {
          str += '<b>C: </b>' + value.surrogateCompany + '&nbsp'
        }
        return str
      }
    },
    formatDate(dateToFormat, newFormat) {
      return utilities.formatDate(dateToFormat, newFormat)
    },
    formatTime(v) {
      if (v.typeId === 8) {
        return moment.utc(v.SuppFutureDate).format('hh:mm A')
      }
      if (!utilities.bookingTypeWithAvailability(v.typeId)) {
        return moment.utc(v.dateCreated).format('hh:mm A')
      }
      return moment.utc(v.dateTime).format('hh:mm A')
    },
    getBookingTypeName(typeId) {
      return this.bookingTypes.find((x) => x.id === typeId).name
    },
    async loadData(date = "") {
      this.bookingsByLocation = []
      if (this.specialist.id != "") {
        this.specialist = await utilities.getSpecialistById(this.specialist.id)
        var startDate = ""
        var endDate = ""
        if (date == "") {
          startDate = moment().format('YYYY-MM-DD')
          endDate = moment().format('YYYY-MM-DD')
        } else {
          startDate = date
          endDate = date
        }

        var params = {
          specialistId: this.specialist.id,
          startDate: startDate,
          endDate: endDate,
        }
        this.bookings = await utilities.getSpecialistBookings(params)
        // Not showing Cancelled booking (id = 6)
        this.bookings = this.bookings.filter(x => Number(x.bookingDetails.status) >= 2 && Number(x.bookingDetails.status) <= 15 && Number(x.bookingDetails.status) != 6)
        this.bookings.sort((a, b) => {
          return moment(new Date(a.bookingDetails.realDate)).isAfter(moment(new Date(b.bookingDetails.realDate))) ? 1 : -1
        }).map(x => {
          if (x.bookingDetails.locationId != '') {
            if (this.bookingsByLocation[x.bookingDetails.locationId] == undefined) this.bookingsByLocation[x.bookingDetails.locationId] = []
            this.bookingsByLocation[x.bookingDetails.locationId].push(x)
          }
        })
        params = {
          StartDate: startDate,
          EndDate: endDate,
        }
        var availabilities = await utilities.getSpecialistAvailabilities(this.specialist.id, "", params)
        availabilities.sort((a, b) => {
          return moment(a.availabilityDate + " " + a.startTime).isAfter(moment(b.availabilityDate + " " + b.startTime)) ? 1 : -1
        })
        if (availabilities.length > 0) {
          var availabiltyHasGeneralInformation = availabilities.filter(x => x.generalInformation.trim() != 0)[0]
          if (availabiltyHasGeneralInformation) this.availability = availabiltyHasGeneralInformation
          else this.availability = availabilities[0]

          this.availability.generalInformation = this.availability.generalInformation.replace(/(?:\r\n|\r|\n)/g, '<br />')
        }
        console.log(this.bookings)

        this.dataKey += 1
      }
    },
  },
  async beforeMount() {
    this.bookingTypes = await utilities.getBookingTypes()
  },
  mounted() {
  },
}
</script>
